/**
 * Simple Link Mega Menu Handler
 * Allows clicking on the link text to navigate, while clicking the caret toggles the menu
 */

// INJECT CSS IMMEDIATELY - BEFORE THE REST OF THE PAGE LOADS
// This CSS will override the browser's default link blue
const style = document.createElement('style');
style.textContent = `
  .simple-link-summary__href {
    color: rgb(var(--color-foreground)) !important;
    text-decoration: none !important;
  }
`;
// Append to head ASAP
if (document.head) {
  document.head.appendChild(style);
} else {
  // If head doesn't exist yet, prepend to html
  document.documentElement.insertBefore(style, document.documentElement.firstChild);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('details.simple-link-mega-menu').forEach(details => {
    const summary = details.querySelector('summary.simple-link-summary');
    const link = summary ? summary.querySelector('.simple-link-summary__href') : null;
    const caret = summary ? summary.querySelector('.icon-caret') : null;

    if (summary && link) {
      summary.addEventListener('click', (e) => {
        const clickedOnCaret = caret && (e.target === caret || caret.contains(e.target));

        if (!clickedOnCaret) {
          // Manual toggle: allows menu to toggle like mega-menu does
          details.open = !details.open;
          e.preventDefault();
          e.stopPropagation();
          
          // Only navigate if href is not "#" (which would scroll to top)
          const href = link.getAttribute('href');
          if (href && href !== '#') {
            window.location.href = href;
          }
        }
      });
    }
  });
});

